import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d01eccf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main",
  style: {"margin":"10px"}
}
const _hoisted_2 = {
  class: "container",
  style: {"height":"55px","padding-bottom":"10px"}
}
const _hoisted_3 = { class: "image2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  href: "/",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"links-container\" data-v-d01eccf0><a href=\"https://sg.shp.ee/Wn1Z7zM\" class=\"qr-link\" target=\"_blank\" data-v-d01eccf0><span data-v-d01eccf0>Click to go to our Shopee store</span><img src=\"/images/redeem/shopee-qrcode.png\" class=\"image-style\" style=\"width:150px;\" data-v-d01eccf0></a><a href=\"https://www.lazada.sg/shop/gda-global-data-assistant\" class=\"qr-link\" target=\"_blank\" data-v-d01eccf0><span data-v-d01eccf0>Click to go to our Lazada store</span><img src=\"/images/redeem/lazada-qrcode.png\" class=\"image-style\" style=\"width:150px;\" data-v-d01eccf0></a></div>", 1)


import { defineComponent, onMounted } from 'vue'
import store from '../store'
import { getI18n } from '../utils'

const __default__ = defineComponent({
  name: 'RedeemGiftResultView'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

onMounted(async () => {
  console.log('RedeemGiftResultView', store)
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_image, { src: './images/gda-log.png' }, null, 8, ["src"])
      ])
    ]),
    (_unref(store).state.redeemResult.code=='ok')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_unref(getI18n)('兑换成功, 二维码已发到你的邮箱', 'redeem success, We\'ve sent the QR code to your email')), 1),
          (_unref(store).state.redeemResult.data.qrcode!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: 'data:image/png;base64,'+_unref(store).state.redeemResult.data.qrcode,
                  class: "image-style",
                  style: {"width":"350px"}
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h2", null, _toDisplayString(_unref(getI18n)('兑换失败', 'redeem fail')) + ":" + _toDisplayString(_unref(store).state.redeemResult.message), 1)
        ])),
    _createVNode(_component_el_divider),
    _createElementVNode("div", null, [
      _createElementVNode("a", _hoisted_8, [
        _createElementVNode("h2", null, _toDisplayString(_unref(getI18n)('查询流量 & FAQ', 'Check Data & FAQ')), 1)
      ])
    ]),
    _createVNode(_component_el_divider),
    _hoisted_9
  ]))
}
}

})